import React, { Component } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'

import {
  EditableTextField,
  EditableSwitch,
  EditableReactSelectAsync,
  EditableReactSingleSelect,
  EditableReactSelectCreatable,
} from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import { searchEmployee } from '../../actions/employee'

const daysoftheweek = [
  { value: 7, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
]
export default class ReportingBroadcastItem extends Component {
  timeout = null
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onSelectChange = (key, input, multiple = false) => {
    if (key === 'frequency' && !!input) {
      const { availableFrequencies = [] } = this.props
      const selectedFrequency =
        availableFrequencies.find((elem) => elem.frequency === input.value) || {}
      this.props.onChange('frequencyDescription', selectedFrequency.description || '')
    }

    if (key === 'subscribers' && !!input) {
      let subscriberIds = input.map((item) => item.value)
      this.props.onChange('subscriberIds', subscriberIds)
    }

    if (key === 'dayoftheweek' && !!input) {
      let dayId = input.value
      this.props.onChange('weeklyDay', dayId)
    }

    if (multiple) {
      !!input && this.props.onChange(key, input)
    } else {
      !!input && this.props.onChange(key, input.value)
    }
  }

  isValidReportType = (reportType) => {
    const { availableReports = [] } = this.props
    return !!availableReports.find((elem) => elem.reportType === reportType)
  }

  convertToOptions = (array, key, value) => {
    return (
      (array &&
        array.map((item) => {
          return {
            label: item[key],
            value: item[value],
          }
        })) ||
      []
    )
  }

  loadEmployees = (term, callback) => {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0) {
      const { employees = [] } = this.props
      const options = this.convertToOptions(employees, 'name', 'id')
      callback(null, { options })
      return
    }

    this.timeout = setTimeout(() => {
      this.props.dispatch(searchEmployee(term)).then((res) => {
        let options = []
        options = res && res.values ? this.convertToOptions(res.values, 'name', 'id') : []
        callback(null, { options })
      })
    }, 500)
  }

  selectedEmployees() {
    const { data = {} } = this.props
    const { subscribers = [] } = data
    if (subscribers.length === 0) {
      return []
    }

    if (subscribers.length > 0 && !!subscribers[0].label && !!subscribers[0].value) {
      return subscribers
    }
    return this.convertToOptions(subscribers, 'name', 'id')
  }

  selectedEmails() {
    const { data = {} } = this.props
    const { subscriberEmailsExternal = [] } = data
    if (subscriberEmailsExternal == null || subscriberEmailsExternal == undefined) {
      return []
    }
    if (subscriberEmailsExternal.length === 0) {
      return []
    }

    if (
      subscriberEmailsExternal.length > 0 &&
      !!subscriberEmailsExternal[0].label &&
      !!subscriberEmailsExternal[0].value
    ) {
      return subscriberEmailsExternal
    }
    let options =
      (subscriberEmailsExternal &&
        subscriberEmailsExternal.map((item) => {
          return {
            label: item,
            value: item,
          }
        })) ||
      []
    this.props.onChange('subscriberEmailsExternal', options)
    return options
  }

  render() {
    const {
      data,
      editMode,
      availableReports = [],
      availableFrequencies = [],
      employees = [],
      shops = [],
    } = this.props
    let day = ''
    if (data && data.weeklyDay && data.weeklyDay !== 0) {
      let obj = daysoftheweek.find((item) => item.value === data.weeklyDay)
      day = obj.label
    }
    return (
      <TableRow>
        <TableCell className="editField" style={{ maxWidth: '80px' }}>
          <EditableReactSingleSelect
            clearable={true}
            valueToRender={data.reportName}
            onChange={(data) => this.onSelectChange('reportType', data)}
            value={data.reportType}
            editMode={editMode}
            options={this.convertToOptions(availableReports, 'name', 'reportType')}
            noResultsText={'No reports found'}
          />
        </TableCell>
        <TableCell>
          <EditableReactSingleSelect
            clearable={true}
            valueToRender={data.frequency}
            onChange={(data) => this.onSelectChange('frequency', data)}
            value={data.frequency}
            editMode={editMode}
            options={this.convertToOptions(availableFrequencies, 'frequency', 'frequency')}
            noResultsText={'No frequencies found'}
          />
          {data.frequency === 'Weekly' && (
            <EditableReactSingleSelect
              clearable={true}
              valueToRender={' ' + day}
              onChange={(data) => this.onSelectChange('dayoftheweek', data)}
              value={data.weeklyDay}
              editMode={editMode}
              options={daysoftheweek}
              noResultsText={'No days found'}
            />
          )}
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.frequencyDescription}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.employee}
            value={data.employee}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">{shops}</TableCell>
        <TableCell className="cell-wrap-word" style={{ minWidth: '120px' }}>
          <EditableReactSelectAsync
            multi={true}
            clearable={true}
            valueToRender={
              data.subscribers &&
              data.subscribers
                .map((subscriber) => subscriber.name || subscriber.label || '--')
                .join(', ')
            }
            onChange={(data) => this.onSelectChange('subscribers', data, true)}
            loadOptions={this.loadEmployees}
            value={this.selectedEmployees()}
            editMode={editMode}
            autoload={false}
            onBlurResetsInput={false}
            portalPlacement={'bottom'}
            options={this.convertToOptions(employees, 'name', 'id')}
            noResultsText={'No employees found'}
          />
        </TableCell>
        <TableCell className="cell-wrap-word" style={{ minWidth: '200px' }}>
          <EditableReactSelectCreatable
            multi={true}
            clearable={true}
            valueToRender={
              data.subscriberEmailsExternal &&
              data.subscriberEmailsExternal
                .map((subscriber) => subscriber.label || subscriber.value || subscriber || '--')
                .join(', ')
            }
            onChange={(data) => this.onSelectChange('subscriberEmailsExternal', data, true)}
            value={this.selectedEmails()}
            editMode={editMode}
            autoload={false}
            onBlurResetsInput={false}
            portalPlacement={'bottom'}
            options={this.convertToOptions(employees, 'email', 'id')}
            noResultsText={'No employees found'}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enable ? 'Active' : 'Inactive'}
            checked={data.enable}
            editMode={editMode}
            onChange={this.onChange('enable', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditActionComponent
            onSave={this.onSave}
            onCancel={this.onCancel}
            onEdit={this.props.enableEdit}
            editMode={editMode}
          />
          {!editMode ? (
            <Button className="danger-button margin" onClick={this.props.onDelete}>
              Delete
            </Button>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Insights/ReportingBroadcastItem.js